import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const numberOfTicketsOptions = [
  {label: '100', value: '100'},
  {label: '1.000', value: '1000'},
  {label: '10.000', value: '10000'},
  {label: '100.000', value: '100000'},
]

export const numberOfTicketsStrategy = optionsToStrategy(numberOfTicketsOptions)